(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["glass-kit-selector"] && !Shopify.designMode) return;
  try {
    (() => {
  function initGlassKitSelector() {
    const root = document.getElementById('glass-inline-kit');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const productInfo = root.closest('product-info') || document;
    const nativeVariantPicker = root.closest('.rte')?.nextElementSibling;
    const modes = root.querySelectorAll('.glass-mode');
    const views = root.querySelectorAll('.glass-view');
    const cards = root.querySelectorAll('.glass-card');
    const add = root.querySelector('.glass-add');
    const buyNow = root.querySelector('.glass-buy-now');
    const note = root.querySelector('.glass-note');
    const mobileBar = root.parentElement?.querySelector('[data-glass-mobile-bar]') || document.querySelector('[data-glass-mobile-bar]');
    const mobileTitle = mobileBar?.querySelector('strong');
    const mobileMeta = mobileBar?.querySelector('span');
    const mobileButton = mobileBar?.querySelector('button');

    if (mobileBar && mobileBar.parentElement !== document.body) {
      document.querySelectorAll('body > [data-glass-mobile-bar]').forEach((bar) => bar.remove());
      document.body.appendChild(mobileBar);
    }

    let currentMode = 'kits';
    let isAdding = false;
    let selectedCard;
    const requestedVariantId = root.dataset.requestedVariantId;
    const requestedCard = requestedVariantId
      ? root.querySelector('.glass-card[data-variant-id="' + CSS.escape(requestedVariantId) + '"]')
      : null;
    const initialCard = (requestedCard && !requestedCard.disabled ? requestedCard : null) ||
      root.querySelector('.glass-view[data-view="kits"] .glass-card[data-default="true"]:not(:disabled)') ||
      root.querySelector('.glass-view[data-view="kits"] .glass-card:not(:disabled)') ||
      root.querySelector('.glass-card:not(:disabled)');

    if (nativeVariantPicker?.tagName?.toLowerCase() === 'variant-picker') {
      nativeVariantPicker.style.display = 'none';
      nativeVariantPicker.setAttribute('aria-hidden', 'true');
    }

    const syncNativeVariant = (card) => {
      const variantTitle = card.dataset.variantTitle;
      const variantId = card.dataset.variantId;
      const radio = productInfo.querySelector('input[type="radio"][value="' + CSS.escape(variantTitle) + '"]');
      const hiddenInputs = productInfo.querySelectorAll('input[name="id"]');

      if (radio && !radio.checked) radio.click();

      hiddenInputs.forEach((input) => {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    const updateCtas = (card) => {
      const title = card.dataset.title;
      const price = card.dataset.price;
      const subtitle = card.dataset.subtitle;

      if (add) add.textContent = root.dataset.addLabel + ' ' + title + ' · ' + price;
      if (mobileTitle) mobileTitle.textContent = title;
      if (mobileMeta) mobileMeta.textContent = price + ' · ' + subtitle;

      if (note) {
        note.textContent = currentMode === 'kits' ? root.dataset.kitNote : root.dataset.refillNote;
        note.classList.remove('is-error');
      }
    };

    const selectCard = (card) => {
      if (!card || card.disabled) return;
      const view = card.closest('.glass-view');

      view.querySelectorAll('.glass-card').forEach((item) => {
        const active = item === card;
        item.classList.toggle('active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      selectedCard = card;
      syncNativeVariant(card);
      updateCtas(card);
    };

    const setMode = (mode, preferredCard) => {
      currentMode = mode;

      modes.forEach((button) => {
        const active = button.dataset.mode === mode;
        button.classList.toggle('active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      views.forEach((view) => {
        const active = view.dataset.view === mode;
        view.hidden = !active;
        view.classList.toggle('active', active);
      });

      const view = root.querySelector('.glass-view[data-view="' + mode + '"]');
      const nextCard = preferredCard || view?.querySelector('.glass-card.active:not(:disabled)') || view?.querySelector('.glass-card:not(:disabled)');
      selectCard(nextCard);
    };

    modes.forEach((button) => {
      button.addEventListener('click', () => setMode(button.dataset.mode));
    });

    cards.forEach((card) => {
      card.addEventListener('click', () => selectCard(card));
    });

    const updateCartDrawerFromSections = (parsedState, sourceButton) => {
      const cartDrawer = document.querySelector('cart-drawer');
      const sectionId = cartDrawer?.getAttribute('data-section-id');
      const sectionHtml = sectionId ? parsedState.sections?.[sectionId] : null;
      if (!cartDrawer || !sectionHtml) return false;

      const parsedHtml = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const currentMiniCart = document.getElementById('MiniCart-' + sectionId);
      const updatedMiniCart = parsedHtml.getElementById('MiniCart-' + sectionId);
      if (!currentMiniCart || !updatedMiniCart) return false;

      currentMiniCart.innerHTML = updatedMiniCart.innerHTML;

      const updatedCount = parsedHtml.querySelector('cart-count');
      if (updatedCount) {
        const itemCount = Number.parseInt(updatedCount.textContent, 10) || 0;
        document.querySelectorAll('cart-count').forEach((count) => {
          count.textContent = updatedCount.textContent;
          count.hidden = itemCount === 0;
          if (updatedCount.hasAttribute('aria-label')) {
            count.setAttribute('aria-label', updatedCount.getAttribute('aria-label'));
          }
        });
      }

      if (!cartDrawer.open) cartDrawer.show(sourceButton);
      return true;
    };

    const refreshCartDrawer = () => {
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { open: true }
      }));
    };

    const addSelectedVariantToDrawer = async (sourceButton) => {
      if (!selectedCard || isAdding) return;

      isAdding = true;
      syncNativeVariant(selectedCard);

      const originalText = sourceButton?.textContent;
      if (sourceButton) {
        sourceButton.disabled = true;
        sourceButton.setAttribute('aria-busy', 'true');
        sourceButton.textContent = root.dataset.addingLabel;
      }

      const resetAddingState = () => {
        isAdding = false;
        if (sourceButton) {
          sourceButton.disabled = false;
          sourceButton.removeAttribute('aria-busy');
          sourceButton.textContent = originalText;
        }
      };

      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
        bubbles: true,
        detail: { sections }
      }));

      const formData = new FormData();
      formData.append('id', selectedCard.dataset.variantId);
      formData.append('quantity', '1');
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);

      let parsedState;
      try {
        const themeApi = window.theme || {};
        const response = await fetch(root.dataset.cartAddUrl || themeApi.routes?.cart_add_url || '/cart/add', {
          method: 'POST',
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });
        parsedState = await response.json();
        const errorMessage = parsedState.description || parsedState.message || root.dataset.errorMessage;

        if (!response.ok || parsedState.status) {
          if (note) {
            note.textContent = errorMessage;
            note.classList.add('is-error');
          }
          resetAddingState();
          return;
        }
      } catch (error) {
        console.log(error);
        if (note) {
          note.textContent = root.dataset.errorMessage;
          note.classList.add('is-error');
        }
        resetAddingState();
        return;
      }

      if (note) {
        note.textContent = currentMode === 'kits' ? root.dataset.kitNote : root.dataset.refillNote;
        note.classList.remove('is-error');
      }

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: parsedState }
      }));

      try {
        if (!updateCartDrawerFromSections(parsedState, sourceButton)) refreshCartDrawer();
      } catch (drawerError) {
        console.log(drawerError);
        refreshCartDrawer();
      } finally {
        resetAddingState();
      }
    };

    const triggerBuyNow = () => {
      if (!selectedCard || isAdding) return;
      syncNativeVariant(selectedCard);

      const isLocalPreview = ['127.0.0.1', 'localhost'].includes(window.location.hostname);
      const returnTo = isLocalPreview ? '/cart' : (root.dataset.checkoutUrl || '/checkout');
      const form = document.createElement('form');
      form.method = 'post';
      form.action = root.dataset.cartAddUrl || '/cart/add';
      form.style.display = 'none';

      [
        ['id', selectedCard.dataset.variantId],
        ['quantity', '1'],
        ['return_to', returnTo]
      ].forEach(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
    };

    if (add) add.addEventListener('click', () => addSelectedVariantToDrawer(add));
    if (buyNow) buyNow.addEventListener('click', triggerBuyNow);
    if (mobileButton) mobileButton.addEventListener('click', () => addSelectedVariantToDrawer(mobileButton));

    const updateMobileBar = () => {
      if (!mobileBar) return;
      mobileBar.hidden = false;
      const selectorPassed = root.getBoundingClientRect().bottom < 120;
      const visible = window.innerWidth < 768 && selectorPassed;
      mobileBar.classList.toggle('is-visible', visible);
      mobileBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    window.addEventListener('scroll', updateMobileBar, { passive: true });
    window.addEventListener('resize', updateMobileBar);

    const initialMode = initialCard?.closest('.glass-view')?.dataset.view || 'kits';
    setMode(initialMode, initialCard);
    updateMobileBar();
    if (!initialCard) {
      [add, buyNow, mobileButton].filter(Boolean).forEach((button) => { button.disabled = true; button.textContent = root.dataset.soldOutLabel; });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlassKitSelector);
  } else {
    initGlassKitSelector();
  }

  document.addEventListener('shopify:section:load', initGlassKitSelector);
  document.addEventListener('shopify:section:select', initGlassKitSelector);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slicemaster-purchase-bottom"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('slice-master-purchase')) {
    customElements.define('slice-master-purchase', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form[is="product-form"]');
        this.addButton = this.querySelector('[name="add"]');
        this.buyNow = this.querySelector('[data-slicemaster-buy-now]');
        this.cartUrl = this.dataset.cartUrl;
        this.cartAddUrl = this.dataset.cartAddUrl;
        this.checkoutUrl = `${window.Shopify.routes.root}checkout`;
        this.buyNowError = this.dataset.buyNowError;
        this.errorMessage = this.querySelector('.slicemaster-form-error');
        this.productInfo = this.closest('product-info');
        this.currentVariant = this.readVariant('[data-selected-variant]');
        this.optimisticModeEnabled = this.isVariantSetEligible(this.readVariants());
        this.stabilizeVariantPicker();
        this.handleOptionChange = (event) => this.onOptionChange(event);
        this.handleNativeVariantChange = (event) => this.onNativeVariantChange(event.detail.variant);
        this.handleBuyNowClick = (event) => this.onBuyNowClick(event);

        this.form?.addEventListener('variant:change', this.handleNativeVariantChange);
        this.productInfo?.addEventListener('change', this.handleOptionChange);
        this.buyNow?.addEventListener('click', this.handleBuyNowClick);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('variant:change', this.handleNativeVariantChange);
        this.productInfo?.removeEventListener('change', this.handleOptionChange);
        this.buyNow?.removeEventListener('click', this.handleBuyNowClick);

        if (this.productInfo?.updateOptionValues === this.stableOptionRefresh) {
          this.productInfo.updateOptionValues = this.nativeOptionRefresh;
        }
      }

      get variantPicker() {
        return this.productInfo?.querySelector('variant-picker');
      }

      onOptionChange(event) {
        if (!event.target.closest('variant-picker')) return;

        const variant = this.findSelectedVariant();
        if (!this.canApplyOptimistically(variant)) {
          this.setBuyNowAvailability(false);
          return;
        }

        this.applyPurchaseVariant(variant);
      }

      onNativeVariantChange(variant) {
        const selectedVariant = this.findSelectedVariant();

        if (selectedVariant && String(selectedVariant.id) !== String(variant?.id)) {
          if (this.canApplyOptimistically(selectedVariant)) {
            this.applyPurchaseVariant(selectedVariant);
          }
          return;
        }

        if (variant) this.currentVariant = variant;
        this.syncVariant(variant);
      }

      async onBuyNowClick(event) {
        event.preventDefault();

        if (this.buyNowBusy || !this.currentVariant?.available) return;

        this.setBuyNowBusy(true);
        this.clearPurchaseError();

        try {
          const response = await fetch(this.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: this.currentVariant.id,
                quantity: 1
              }]
            })
          });
          const result = await response.json();

          if (!response.ok) {
            throw new Error(result.description || result.message || this.buyNowError);
          }

          window.location.assign(this.checkoutUrl);
        } catch (error) {
          this.showPurchaseError(error.message || this.buyNowError);
          this.setBuyNowBusy(false);
        }
      }

      findSelectedVariant() {
        const picker = this.variantPicker;
        if (!picker) return null;
        if (picker.currentVariant) return picker.currentVariant;

        const selectedOptions = Array.from(picker.querySelectorAll('fieldset')).map((fieldset) => {
          return fieldset.querySelector('input:checked')?.value;
        });

        if (selectedOptions.some((value) => !value)) return null;

        return this.readVariants().find((variant) => {
          if (variant.options.length !== selectedOptions.length) return false;
          return variant.options.every((option, index) => option === selectedOptions[index]);
        }) || null;
      }

      readVariants() {
        const variants = this.readVariant('[data-variants]');
        return Array.isArray(variants) ? variants : [];
      }

      readVariant(selector) {
        const data = this.variantPicker?.querySelector(selector)?.textContent;
        if (!data) return null;

        try {
          return JSON.parse(data);
        } catch {
          return null;
        }
      }

      isVariantSetEligible(variants) {
        if (!variants.length) return false;

        const reference = variants[0];
        return variants.every((variant) => {
          const valid = variant?.id
            && Array.isArray(variant.options)
            && typeof variant.available === 'boolean';
          const samePrice = Number(variant.price) === Number(reference.price)
            && Number(variant.compare_at_price || 0) === Number(reference.compare_at_price || 0);

          return Boolean(valid && samePrice);
        });
      }

      stabilizeVariantPicker() {
        if (!this.optimisticModeEnabled || typeof this.productInfo?.updateOptionValues !== 'function') return;

        this.nativeOptionRefresh = this.productInfo.updateOptionValues;
        this.stableOptionRefresh = () => {};
        this.productInfo.updateOptionValues = this.stableOptionRefresh;
      }

      canApplyOptimistically(variant) {
        if (!this.optimisticModeEnabled || !variant?.id || typeof variant.available !== 'boolean') return false;
        if (!this.currentVariant) return true;

        return Number(variant.price) === Number(this.currentVariant.price)
          && Number(variant.compare_at_price || 0) === Number(this.currentVariant.compare_at_price || 0);
      }

      applyPurchaseVariant(variant) {
        const variantInput = this.form?.querySelector('input[name="id"]');
        if (variantInput) variantInput.value = String(variant.id);

        this.setAddButtonAvailability(variant.available);
        this.syncVariant(variant);
        this.updateUrl(variant.id);
        this.currentVariant = variant;
        this.dataset.optimisticVariantId = String(variant.id);
      }

      setAddButtonAvailability(available) {
        if (!this.addButton || this.addButton.hasAttribute('aria-busy')) return;

        if (typeof this.form?.toggleSubmitButton === 'function') {
          this.form.toggleSubmitButton(!available, theme.variantStrings.soldOut);
        } else {
          this.addButton.toggleAttribute('disabled', !available);
        }

        if (available) this.addButton.removeAttribute('aria-disabled');
      }

      updateUrl(variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({ path: url.toString() }, '', url.toString());
      }

      syncVariant(variant) {
        if (!this.buyNow) return;

        const available = Boolean(variant?.available);
        this.setBuyNowAvailability(available);
      }

      setBuyNowAvailability(available) {
        if (!this.buyNow) return;

        this.buyNow.classList.toggle('is-disabled', !available);
        this.buyNow.setAttribute('aria-disabled', String(!available));

        if (!this.buyNowBusy) {
          this.buyNow.toggleAttribute('disabled', !available);
        }
      }

      setBuyNowBusy(busy) {
        if (!this.buyNow) return;

        this.buyNowBusy = busy;
        this.buyNow.setAttribute('aria-busy', String(busy));
        this.buyNow.toggleAttribute('disabled', busy || !this.currentVariant?.available);
      }

      clearPurchaseError() {
        if (!this.errorMessage) return;

        this.errorMessage.hidden = true;
        this.errorMessage.textContent = '';
      }

      showPurchaseError(message) {
        if (!this.errorMessage) return;

        this.errorMessage.textContent = message;
        this.errorMessage.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
